<template>
  <div>
    <div class="banner"></div>
    <!-- $ 筛选 模块 -->
    <div class="pick-box">
      <div class="tit">
        <div class="left">
          我的商品库
        </div>
        <div class="right">
          <span>
            通用设置：
          </span>
          <span style="color: #FE2C55;cursor: pointer;" @click="servePercent()">
            报团服务费
          </span>
        </div>
      </div>
      <div class="main">
        <div class="item">
          <div class="l">商品标题</div>
          <div class="r">
            <el-input
              size="mini"
              v-model="formLine.title"
              placeholder="请输入商品关键词"
            ></el-input>
          </div>
        </div>
        <div class="item">
          <div class="l">商品ID</div>
          <div class="r">
            <el-input
              size="mini"
              v-model="formLine.product_id"
              placeholder="请输入商品ID"
            ></el-input>
          </div>
        </div>
        <div class="item">
          <div class="l">店铺名称</div>
          <div class="r">
            <el-input
              size="mini"
              v-model="formLine.shop_name"
              placeholder="请输入店铺名称"
            ></el-input>
          </div>
        </div>
        <div class="item">
          <div class="l">活动名称</div>
          <div class="r">
            <el-input
              size="mini"
              v-model="formLine.activity_name"
              placeholder="请输入活动名称"
            ></el-input>
          </div>
        </div>
        <!-- <div class="item">
          <div class="l">合作来源</div>
          <div class="r">
            <el-select v-model="value" placeholder="请选择" size="mini">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <div class="l">补录进度</div>
          <div class="r">
            <el-select v-model="value" placeholder="请选择" size="mini">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div> -->
        <div class="btn-box">
          <el-button size="mini" type="danger" @click="submit()">搜索</el-button>
          <el-button size="mini" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
    <!-- *状态选择 -->
    <div class="wrap">
      <div class="statusLine">
        <div class="left">
          <div @click="changeStatus(2)" :class="{ active: chooseIndex == 2 }">
            未上架
          </div>
          <div @click="changeStatus(1)" :class="{ active: chooseIndex == 1 }">
            已上架
          </div>
        </div>
        <div class="right">
          <el-button size="mini">批量补录商品详情</el-button>
          <el-button size="mini">导出托管商品</el-button>
          <el-button size="mini">导出商品</el-button>
        </div>
      </div>
    </div>
    <!-- $ 表格 模块 -->
    <div class="table-box">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="商品信息" width="500">
          <template slot-scope="scope">
            <div class="goodsInfo">
              <img :src="scope.row.cover" alt="" />
              <div class="r">
                <div class="tit">
                  {{ scope.row.title || "--" }}
                </div>
                <div class="txt">
                  商品ID：
                  {{ scope.row.product_id || "--" }}
                </div>
                <div class="txt">
                  店铺：
                  {{ scope.row.shop_name || "--" }}
                </div>
                <div class="txt1">
                  {{ scope.row.category_name || '--' }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="价格" width="130">
          <template slot-scope="scope">
            <div class="num-box">
              <div>
                现售：<span>￥{{ scope.row.price || 0 }}</span>
              </div>
              <div>活动：<span>￥223.2</span></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="佣金率" width="130">
          <template slot-scope="scope">
            <div class="num-box">
              <div>
                普通：<span>{{ scope.row.cos_ratio || 0 }}%</span>
              </div>
              <div>
                活动：<span>{{ scope.row.activity_cos_ratio || 0 }}%</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="服务费率" width="130">
          <template slot-scope="scope">
            <div class="num-box">
              <div>
                我的：<span>{{ scope.row.service_ratio || 0 }}%</span>
              </div>
              <div>
                活动：<span>{{ scope.row.service_ratio || 0 }}%</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="活动信息" width="380">
          <template slot-scope="scope">
            <div class="num-box">
              <div>
                活动名称：<span>{{ scope.row.activity_name || "--" }}</span>
              </div>
              <div>
                推广时间：<span
                  >{{ scope.row.promotion_start_time || "--" }}~{{
                    scope.row.promotion_end_time || "--"
                  }}</span
                >
              </div>
              <div>推广状态：<span>暂无字段--暂存</span></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="活动信息" width="120">
          <!-- <template slot-scope="scope"> -->
          <!-- 接口无字段暂存 -->
          <template>
            <div class="num-box">
              <div>托管：<span>--</span></div>
              <div>手机：<span>--</span></div>
              <div>微信：<span>--</span></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="220">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              style="border: none; width: 110px; text-align: center"
            >
              <div style="color: #fe2c55; font-size: 9px; font-weight: 400">
                复制链接
              </div>
            </el-button>
            <el-button
              size="mini"
              type="text"
              style="border: none; width: 68px; text-align: center"
              @click="handleshelve(scope.row)"
            >
              <div style="color: #fe2c55; font-size: 9px; font-weight: 400">
                {{scope.row.online_status==1?'下架':'上架'}}
              </div>
            </el-button>
            <el-button
              size="mini"
              type="text"
              style="border: none; width: 90px; text-align: center"
            >
              <div style="color: #fe2c55; font-size: 9px; font-weight: 400">
                查看详情
              </div>
            </el-button>
            <el-button
              size="mini"
              type="text"
              style="border: none; width: 90px; text-align: center"
              @click="editGoods(scope.row)"
            >
              <div style="color: #fe2c55; font-size: 9px; font-weight: 400">
                编辑商品
              </div>
            </el-button>
            <el-button
              size="mini"
              type="text"
              style="border: none; width: 90px; text-align: center"
            >
              <div style="color: #fe2c55; font-size: 9px; font-weight: 400">
                上传手卡
              </div>
            </el-button>
            <el-button
              size="mini"
              type="text"
              style="border: none; width: 90px; text-align: center"
              @click="openApply(scope.row)"
            >
              <div style="color: #fe2c55; font-size: 9px; font-weight: 400">
                申请报团
              </div>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :total="total"
        :current_page="formLine.page"
        @sizeChange="sizeChange"
        @currentChange="currentChange"
      ></pagination>
      <!-- 设置服务费率弹窗 -->
      <percentDialog :percentVisible='percentVisible' @success='success' @cancel='cancel'></percentDialog>
      <!-- 编辑商品弹窗 -->
      <editDialog :editVisible='editVisible' :data="eachGoodInfo" @close='close'></editDialog>
      <!-- 申请报团弹窗 -->
      <applyDialog :applyVisible="applyVisible" :data="eachGoodInfo" @successApply="successApply" @cancelApply="cancelApply"></applyDialog>
    </div>
  </div>
</template>

<script>// @ts-nocheck
import { getMygoodsList, goodsShelve, getServePercent } from "@/api/goods.js";
import { regFenToYuan } from "@/utils/commen.js";
import pagination from "@/components/Pagination/index.vue";
import percentDialog from './servePercentDialog/index.vue';
import editDialog from './editGoodsDialog/index.vue';
import applyDialog from './applyDialog/index.vue';
export default {
  data() {
    return {
      // $ 筛选 模块
      formLine: {
        title: "",
        product_id: "",
        shop_name: "",
        activity_name: "",
        online_status: 2,
        page: 1,
        page_size: 10,
      },
      // 筛选 -- 默认选择未上架
      chooseIndex: 2,
      // 表格数据模块
      tableData: [],
      // table总数据
      total: 0,
      // 服务费率弹窗visible
      percentVisible: false,
      // 编辑商品的弹窗visible
      editVisible: false,
      // 申请报团的弹窗visible
      applyVisible: false,
      // 保存当前点击的商品信息
      eachGoodInfo: {},
      // 是否设置了服务费率
      isRate: false
    };
  },
  // 引入子组件
  components: {
    pagination,
    percentDialog,
    editDialog,
    applyDialog
  },
  created() {
    // 挂载分转元函数
    this.regFenToYuan = regFenToYuan;
  },
  mounted() {
    this.getMygoodsList();
    this.getServePercent();
  },
  methods: {
    // 获取服务费率
    getServePercent(){
      getServePercent({}).then( res => {
        if(res.code==800){
          if(res.data == 0){
            this.isRate = false
          }else{
            this.isRate = true
          }
        }
      })
    },
    // 申请报团弹窗
    openApply(info){
      if(this.isRate){
        this.applyVisible = true;
        this.eachGoodInfo = info
      }else{
        this.$message.error("请先设置报团服务费率")
      }
    },
    // 取消申请报团弹窗回调
    cancelApply(info){
      if(info=='cancel'){
        this.applyVisible = false;
      }
    },
    // submit
    successApply(info){
      if(info == 'success'){
        this.applyVisible = false;
        this.getMygoodsList()
      }
    },
    // 搜索
    submit(){
      this.getMygoodsList();
    },
    // 重置
    reset(){
      this.formLine.title = '';
      this.formLine.product_id = '';
      this.formLine.shop_name = '';
      this.formLine.activity_name = '';
      this.formLine.online_status = '';
      this.formLine.page = 1;
      this.formLine.page_size = 10;
      //
      this.getMygoodsList()
    },
    // 关闭编辑商品的弹窗
    close(info){
      if(info=='cancel'){
        this.editVisible = false
      }else{
        this.editVisible = false
        this.getMygoodsList()
      }
    },
    // 编辑商品
    editGoods(item){
      this.eachGoodInfo = JSON.parse(JSON.stringify(item))
      this.editVisible = true
    },
    // 获取我的商品库
    getMygoodsList() {
      getMygoodsList({
        ...this.formLine,
      }).then((res) => {
        if (res.code == 800) {
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    // 商品上下架操作
    handleshelve(row){
      // 判断上架还是下架  1--下架  2-上架
      this.$confirm(`${row.online_status==2?'上架':'下架'}后,小程序用户${row.online_status==2?'可':'不可'}浏览此商品信息`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        goodsShelve({
          action: row.online_status,
          product_id: row.product_id,
          activity_id: row.activity_id
        }).then(res => {
          if(res.code==800){
            this.$message.Apply(res.msg)
            this.getMygoodsList()
          }
        })
      }).catch(() => {
        // handle error
      });
    },
    // 报团服务费率设置
    servePercent(){
      this.percentVisible = true
    },
    //报团服务费率-回调-Apply-cancel
    success(val){
      if(val=='success'){
        this.percentVisible = false
      }
    },
    cancel(val){
      if(val=='cancel'){
        this.percentVisible = false
      }
    },
    // 切换状态查询
    changeStatus(index) {
      this.chooseIndex = index;
      this.formLine.online_status = index;
      this.formLine.page = 1;
      this.getMygoodsList();
    },
    // 分页回调
    sizeChange(val) {
      this.formLine.page_size = val;
      this.getMygoodsList();
    },
    currentChange(val) {
      this.formLine.page = val;
      this.getMygoodsList();
    },
  },
};
</script>

<style lang="scss" scoped>
// 调整分页位置
/deep/.el-pagination {
  text-align: center;
  margin-top: 40px;
}
.banner {
  height: 130px;
  background: #ffffff;
  border-radius: 4px;
  margin-bottom: 10px;
}
// $ 筛选 模块
.pick-box {
  padding-top: 24px;
  padding-left: 24px;
  height: 122px;
  line-height: 1;
  background: #ffffff;
  box-shadow: 0px -1px 0px 0px #e6e7eb;
  border-radius: 4px 4px 0px 0px;
  box-sizing: border-box;
  border-bottom: 1px solid #e6e7eb;
  .tit {
    font-size: 16px;
    color: #45474d;
    font-weight: bold;
    margin-bottom: 26px;
    .left{
      float: left;
    }
    .right{
      float: right;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #45474D;
      margin-right: 25px;
    }
  }
  .main {
    display: flex;
    align-items: center;
    font-size: 12px;
    .item {
      display: flex;
      align-items: center;
      margin-right: 16px;
      .l {
        width: 48px;
        font-size: 12px;
        color: #8a8e99;
        margin-right: 8px;
      }
      .r {
        // width: 120px;
        flex: 1;
      }
    }
    .btn-box {
      flex: 1;
      padding-right: 24px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      div {
        width: 50px;
        height: 32px;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 1;
      }
      .btn1 {
        background-color: #fe2c55;
        color: #fff;
        margin-right: 10px;
      }
      .btn2 {
        background-color: #ffffff;
        color: #45474d;
        border: 1px solid #e6e7eb;
      }
    }
  }
}
.wrap {
  height: 50px;
  background: #ffffff;
}
.statusLine {
  // width: 1250px;
  background: #ffffff;
  height: 24px;
  padding-top: 14px;
  display: flex;
  justify-content: space-between;
  .left {
    height: 24px;
    display: flex;
    line-height: 24px;
    div {
      margin: 0 10px;
      font-size: 11px;
      cursor: pointer;
    }
    .active {
      color: #fe2c55;
      border-bottom: solid 2px #fe2c55;
      margin-bottom: -5px;
    }
  }
  .right {
    margin-right: 22px;
    height: 24px;
    font-size: 9px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #8a8e99;
    line-height: 9px;
  }
}
// $ 表格 模块
.table-box {
  // margin-top: 10px;
  .goodsInfo {
    display: flex;
    align-items: center;
    img {
      width: 80px;
      height: 80px;
      background: #bfbfbf;
      border-radius: 4px;
      margin-right: 16px;
    }
    .r {
      font-size: 14px;
      color: #8a8e99;
      line-height: 1;
      .tit {
        width: 390px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 16px;
        color: #45474d;
        margin-bottom: 12px;
      }
      .txt {
        margin-bottom: 12px;
      }
      .txt1 {
        color: #fe2c55;
      }
    }
  }
  .num-box {
    font-size: 14px;
    color: #8a8e99;
    span {
      color: #45474d;
    }
    > div {
      margin-bottom: 16px;
    }
  }
}
</style>